export default "__VITE_ASSET__Coqscg$E__"